import React, { createContext, useContext, PropsWithChildren } from 'react'
import { ItemProductCart } from './ProductSummary'

interface ProductContextProps {
  item: ItemProductCart
}

const ProductContext = createContext<ProductContextProps | null>(null)

export function ProductProvider({
  children,
  ...value
}: PropsWithChildren<ProductContextProps>) {
  return (
    <ProductContext.Provider value={value}>{children}</ProductContext.Provider>
  )
}

export function useProductContext() {
  const context = useContext(ProductContext)
  if (!context) {
    throw new Error(
      `ProductSummary compound components cannot be rendered outside the ProductSummary component`
    )
  }
  return context
}
